export default {
    ADMINISTRATIVAMENTE: { texto: 'Administrativamente', valor: 'ADMINISTRATIVAMENTE' },
    DETERMINACAO_TCE: { texto: 'Determinação TCE', valor: 'DETERMINACAO_TCE' },
    DECISAO_JUDICIAL: { texto: 'Decisão Judicial', valor: 'DECISAO_JUDICIAL' }
}